export const unpluggedBooks = [
  {
    author: "Daniella Efrach",
    blurb: "Transform input to output with math operations.",
    bookCover: "/color_1.png",
    category: "UNPLUGGED",
    courses: [],
    coverImage:
      "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/math-operations.png",
    id: 9999999,
    owner: null,
    ownerId: 16,
    pages: [],
    published: true,
    readyForPublish: false,
    tags: [],
    title: "Math Input/Output Activity",
    link: "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/math_io_pipeline_functions.pdf",
  },
  {
    author: "Thomas",
    blurb: "Learn about loops and abstraction through a maze.",
    bookCover: "/color_7.png",
    category: "UNPLUGGED",
    courses: [],
    coverImage:
      "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/arrow.png",
    id: 9999998,
    owner: null,
    ownerId: 16,
    pages: [],
    published: true,
    readyForPublish: false,
    tags: [],
    title: "Maze Solver Game",
    link: "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/maze_solver.pdf",
  },
  {
    author: "Thomas",
    blurb: "A matching game with computer components.",
    bookCover: "/color_4.png",
    category: "UNPLUGGED",
    courses: [],
    coverImage:
      "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/deck-of-cards-clipart-sm.png",
    id: 9999997,
    owner: null,
    ownerId: 16,
    pages: [],
    published: true,
    readyForPublish: false,
    tags: [],
    title: "Card Games",
    link: "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/CardGames.pdf",
  },
  {
    author: "Zoe Hite",
    blurb: "Grid puzzle activity teaching algorithms.",
    bookCover: "/color_2.png",
    category: "UNPLUGGED",
    courses: [],
    coverImage:
      "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/mazeIcon.png",
    id: 9999996,
    owner: null,
    ownerId: 16,
    pages: [],
    published: true,
    readyForPublish: false,
    tags: [],
    title: "Grid Puzzle",
    link: "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/GridPuzzleAlgorithms.pdf",
  },
  {
    author: "Vee",
    blurb: "Learn about reinforcement learning using Skittles!",
    bookCover: "/color_3.png",
    category: "UNPLUGGED",
    courses: [],
    coverImage:
      "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/rl_skittles.png",
    id: 9999995,
    owner: null,
    ownerId: 16,
    pages: [],
    published: true,
    readyForPublish: false,
    tags: [],
    title: "Reinforcement Learning with Skittles",
    link: "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/Reinforcement_Learning_With_Skittles.pdf",
  },
  {
    author: "Norah",
    blurb: "Learn about computer parallelization!",
    bookCover: "/color_5.png",
    category: "UNPLUGGED",
    courses: [],
    coverImage:
      "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/Parallelization_Icon.png",
    id: 9999994,
    owner: null,
    ownerId: 16,
    pages: [],
    published: true,
    readyForPublish: false,
    tags: [],
    title: "Parallelization",
    link: "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/Parallelization_Activity.pdf",
  },
  {
    author: "Norah",
    blurb: "Learn about LLMs using recipes!",
    bookCover: "/color_6.png",
    category: "UNPLUGGED",
    courses: [],
    coverImage:
      "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/LLMs_Lesson_Icon.png",
    id: 9999993,
    owner: null,
    ownerId: 16,
    pages: [],
    published: true,
    readyForPublish: false,
    tags: [],
    title: "Recipe for LLMs",
    link: "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/LLMs_Lesson_Plan.pdf",
  },
  {
    author: "Jenna",
    blurb:
      'Learn how games "think" by exploring if-statements and loops through videos, activities, and gameplay.',
    bookCover: "/color_2.png",
    category: "UNPLUGGED",
    courses: [],
    coverImage:
      "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/controller.jpg",
    id: 9999992,
    owner: null,
    ownerId: 16,
    pages: [],
    published: true,
    readyForPublish: false,
    tags: [],
    title: "Intro to Game Logic",
    link: "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/Intro_to_Game_Logic.pdf",
  },
  {
    author: "Martin",
    blurb:
      "Learn about algorithms and why clear, step-by-step instructions are important in programming.",
    bookCover: "/color_1.png",
    category: "UNPLUGGED",
    courses: [],
    coverImage:
      "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/shoelace.png",
    id: 9999991,
    owner: null,
    ownerId: 16,
    pages: [],
    published: true,
    readyForPublish: false,
    tags: [],
    title: "Shoelace Algorithms",
    link: "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/Shoelace_Algorithms.pdf",
  },
  {
    author: "Martin",
    blurb:
      "Learn about For Loops in programming and how they help make code shorter and more efficient.",
    bookCover: "/color_7.png",
    category: "UNPLUGGED",
    courses: [],
    coverImage:
      "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/lego_for_loop.png",
    id: 9999990,
    owner: null,
    ownerId: 16,
    pages: [],
    published: true,
    readyForPublish: false,
    tags: [],
    title: "Lego For Loops",
    link: "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/Lego_For_Loops.pdf",
  },
  {
    author: "Martin",
    blurb: "Learn about how computers learn.",
    bookCover: "/color_8.png",
    category: "UNPLUGGED",
    courses: [],
    coverImage:
      "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/supervised_learning.png",
    id: 9999989,
    owner: null,
    ownerId: 16,
    pages: [],
    published: true,
    readyForPublish: false,
    tags: [],
    title: "Supervised vs Unsupervised Learning",
    link: "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/Supervised_v_Unsupervised_Learning.pdf",
  },
  {
    author: "Martin",
    blurb: "Explore how AI makes decisions by playing Rock Paper Scissors.",
    bookCover: "/color_3.png",
    category: "UNPLUGGED",
    courses: [],
    coverImage:
      "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/rock_paper_scissors.png",
    id: 9999988,
    owner: null,
    ownerId: 16,
    pages: [],
    published: true,
    readyForPublish: false,
    tags: [],
    title: "Rock Paper Scissors AI Activity",
    link: "https://codekids-minio.endeavour.cs.vt.edu/codekids/unplugged/Rock_Paper_Scissors_AI_Activity.pdf",
  },
];
